import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { TemplateEntry } from '@cli-types/next-adapter/commands.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { applyAdminNamespaceToPath } from '@next-adapter/config/namespace/apply-admin-namespace-to-path.js'
import { applyNextCacheApiForVersion } from '@next-adapter/template-reader/apply-next-cache-api-for-version.js'
export function applyNamespaceToTemplateEntry(
  entry: TemplateEntry,
  config: ResolvedBetterstartConfig,
  cwd: string
) {
  const namespace = config.frameworkConfig.next.namespace
  const context = { config, cwd }
  const relPath = typeof entry.relPath === 'function' ? entry.relPath(context) : entry.relPath

  return {
    relPath: applyAdminNamespaceToPath(relPath, namespace),
    content: applyAdminNamespaceToContent(
      applyNextCacheApiForVersion(entry.content(context), config.nextMajorVersion),
      namespace
    )
  }
}
